import AbstractFilter from './AbstractFilter';

export default class ToString extends AbstractFilter
{
    filter(value: any): string
    {
        return String(value);
    }
}